import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
// import turf from 'turf'
// material
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
// import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import {
  default as React,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import GoogleLogin from "react-google-login";
import Select from "react-select";
// import { isEqual } from 'lodash';
import { v4 as uuidv4 } from "uuid";
import { mapContext } from "./context/mapContext";
import {
  accidentTypes,
  addEpochDates,
  decodeInjuries,
  functionalClassLookup,
  mostSevereInjury,
  parseParms,
} from "./lib/Utils";

mapboxgl.accessToken =
  "pk.eyJ1IjoibGtsZXBuZXIiLCJhIjoiY2t3aWV5a2g1MTdpaDJvcWJ4MWV2d2czdyJ9.dUMp9qUpBiHFmL3n1pfnOQ";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default Map;

let popup;

function Map() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [currentLat, setCurrentLat] = useState(41.944);
  const [currentLong, setCurrentLong] = useState(-74.311);
  const [currentZoom, setCurrentZoom] = useState(8);

  const [hash, setHash] = useHash();
  const [currentViewHash, setCurrentViewHash] = useState(null);

  const [crashes, setCrashes] = useState([]);
  const [currentCrashId, setCurrentCrashId] = useState(null);
  const [popupCrashId, setPopupCrashId] = useState(null);
  const [bikeCrashes, setBikeCrashes] = useState([]);
  const [pedCrashes, setPedCrashes] = useState([]);
  const [crashesFiltered, setCrashesFiltered] = useState([]);

  let baseUrl = "http://localhost:4000/local-dev-data/";
  if (
    window.location.href.indexOf("localhost") === -1 &&
    window.location.href.indexOf("127.0.0.1") === -1
  ) {
    baseUrl = "https://s3.amazonaws.com/net.livefeed.public.data/";
  }
  const countyOutlineUrl = baseUrl + "ulster-county-outline.geojson";
  const crashesUrl = baseUrl + "nysdot-ulster-crashes-bike-ped-other.geojson";
  const roadUrl = baseUrl + "NYS-Roadway-Inventory-Ulster5.geojson";
  const ucSpeedUrl = baseUrl + "UCDPW-Speeds-Nearest-RIS.geojson";
  const ucRoadsUrl = baseUrl + "UCDPW_Speeds.GEOJSON";
  const ucRoadsJoinedUrl =
    baseUrl + "UCDPW_speeds_joined_with_nysdot_ris.geojson";

  const [user, setUser] = useState(null);
  const [startDate, setStartDate] = useState(2002);
  const [endDate, setEndDate] = useState(2021);
  const [injuryFilter, setInjuryFilter] = useState("all");
  const [cacheBust, setCacheBust] = useState("none");

  // about modal handling
  const [modalOpen, setModalOpen] = useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  useEffect(() => {
    console.log("getting user data");
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      console.log("loggedInUser", loggedInUser);
      window.loggedInUser = loggedInUser;
      const foundUser = JSON.parse(loggedInUser);
      console.log("foundUser", foundUser);
      setUser(foundUser);
      setModalOpen(false);
    }
  }, []);

  window.openStreetView = (lng, lat) => {
    //console.log('openStreetView: ', lng, lat)
    let URL = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`;
    window.open(URL, "_blank");
  };

  window.openAccidentDetails = async (caseNumber) => {
    console.log("openAccidentDetails: " + caseNumber);

    const args = `
        mutation {
          "putAccidentDetails( accidentDetails: [{ 
              caseNumber: "1234", type: "photo", sortOrder: 1
            }]
          ) {
            id
            caseNumber
            type
            }"
        }`;

    const requestPayload = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(args),
    };
    const res = await fetch("/graphql", requestPayload);

    const jsonResponse = await res.json();
    console.log("opening jsonResponse", jsonResponse);
  };

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: { lng: currentLong, lat: currentLat },
      zoom: currentZoom,
      attributionControl: false,
      //hash: "zyx",
    }).addControl(
      new mapboxgl.AttributionControl({
        compact: true,
        customAttribution:
          '© SharedRoads.com | © <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      })
    );

    // Add zoom and rotation controls to the map.
    map.current.addControl(
      new mapboxgl.NavigationControl({
        visualizePitch: false,
        showCompass: false,
      })
    );

    map.current.on("load", () => {
      console.log("map load");

      map.current.addSource("county-outline-source", {
        type: "geojson",
        data: null,
        //promoteId: { original: "GIS_ID" },
        generateId: true,
      });

      map.current.addLayer({
        id: "county-outline",
        source: "county-outline-source",
        type: "line",
        layout: {
          "line-join": "miter",
          "line-cap": "butt",
        },
        paint: {
          "line-color": "green",
          "line-width": {
            base: 2.75,
            stops: [
              [12, 6],
              [17, 12],
            ],
          },
          "line-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0.5,
          ],
        },
      });

      map.current.addSource("road-inventory", {
        type: "geojson",
        data: null,
        //promoteId: { original: "GIS_ID" },
        generateId: true,
      });

      map.current.addLayer({
        id: "roads",
        source: "road-inventory",
        type: "line",
        layout: {
          "line-join": "miter",
          "line-cap": "butt",
        },
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "grey",
            "lightgrey",
          ],
          "line-width": {
            base: 2.75,
            stops: [
              [12, 6],
              [17, 12],
            ],
          },
          "line-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0.5,
          ],
        },
      });

      map.current.addSource("county-road-inventory", {
        type: "geojson",
        data: null,
        //promoteId: { original: "GIS_ID" },
        generateId: true,
      });

      map.current.addLayer({
        id: "county-roads",
        source: "county-road-inventory",
        type: "line",
        layout: {
          "line-join": "miter",
          "line-cap": "butt",
        },
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "blue",
            "skyblue",
          ],
          "line-width": {
            base: 2.75,
            stops: [
              [12, 6],
              [17, 12],
            ],
          },
          "line-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0.5,
          ],
        },
      });

      map.current.addSource("crashes-source", {
        type: "geojson",
        data: null,
        cluster: true,
        clusterMaxZoom: 12, // Max zoom to cluster points on
        clusterMinPoints: 10, // Minimum number of points necessary to form a cluster
        clusterRadius: 25, // Radius of each cluster when clustering points (defaults to 50)
      });

      map.current.addLayer({
        id: "clusters",
        type: "circle",
        source: "crashes-source",
        filter: ["has", "point_count"],
        paint: {
          // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
          // with three steps to implement three types of circles:
          //   * Blue, 20px circles when point count is less than 100
          //   * Yellow, 30px circles when point count is between 100 and 750
          //   * Pink, 40px circles when point count is greater than or equal to 750
          "circle-color": [
            "step",
            ["get", "point_count"],
            "#51bbd6",
            100,
            "#f1f075",
            750,
            "#f28cb1",
          ],
          "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            100,
            30,
            750,
            40,
          ],
        },
      });

      map.current.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "crashes-source",
        filter: ["has", "point_count"],
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 12,
        },
      });

      map.current.addLayer({
        id: "unclustered-point",
        type: "circle",
        source: "crashes-source",
        filter: ["!", ["has", "point_count"]],
        paint: {
          // Color circles by ACCD_TYP, using a `match` expression.
          "circle-color": [
            "match",
            ["get", "mostSevereInjury"],
            "K",
            "RED",
            "A",
            "ORANGE",
            "B",
            "YELLOW",
            "C",
            "slategray",
            "silver",
          ],
          "circle-radius": {
            base: 2.75,
            stops: [
              [12, 6],
              [22, 380],
            ],
          },
          "circle-stroke-width": 1,
          "circle-stroke-color": "#fff",
        },
      });

      // map.current.addLayer({
      //   id: "unclustered-point",
      //   type: "circle",
      //   source: "crashes-source",
      //   paint: {
      //     // Make circles larger as the user zooms from z12 to z22.
      // "circle-radius": {
      //   base: 2.75,
      //   stops: [
      //     [12, 6],
      //     [22, 380],
      //   ],
      // },
      //
      //     // Color circles by ACCD_TYP, using a `match` expression.
      //     "circle-color": [
      //       "match",
      //       ["get", "mostSevereInjury"],
      //       "K",
      //       "RED",
      //       "A",
      //       "ORANGE",
      //       "B",
      //       "YELLOW",
      //       "C",
      //       "slategray",
      //       "silver",
      //     ],
      //   },
      // });

      fetchCrashes();
      fetchCountyOutline();
    });
  });

  const fetchCrashes = async () => {
    try {
      const response = await fetch(crashesUrl);
      const jsonResponse = await response.json();

      const refinedCrashes = {
        type: "FeatureCollection",
        name: "nys-dot-ulster-crashes-pedestrian",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: [],
      };

      refinedCrashes.features = jsonResponse.features
        .map((f) => mostSevereInjury(f))
        .map((f) => addEpochDates(f))
        .sort((a, b) => b.accidentDateEpoch - a.accidentDateEpoch);

      console.log("refinedCrashes", refinedCrashes);

      setCrashes(refinedCrashes);
      setCrashesFiltered(refinedCrashes);
      setCacheBust(Math.random());
      map.current.getSource("crashes-source").setData(refinedCrashes);

      //rotateCamera(0);

      // Create a popup, but don't add it to the map yet.
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        closeOnMove: true,
      });

      // inspect a cluster on click
      map.current.on("click", "clusters", (e) => {
        console.log("cluster click");
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ["clusters"],
        });
        const clusterId = features[0].properties.cluster_id;
        map.current
          .getSource("crashes-source")
          .getClusterExpansionZoom(clusterId, (err, zoom) => {
            if (err) return;

            map.current.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom,
            });
          });
      });

      map.current.on("mouseenter", "unclustered-point", (e) => {
        setCacheBust(Math.random());
        setPopupCrashId(Number(e.features[0].properties.CASE_NUM));
        //showPopup(e, popup);
      });

      map.current.on("touchstart", "unclustered-point", (e) => {
        //showPopup(e, popup);
        setCacheBust(Math.random());
        setPopupCrashId(Number(e.features[0].properties.CASE_NUM));
      });

      // map.current.on("mouseleave", "places", () => {
      //   map.current.getCanvas().style.cursor = "";
      //   popup.remove();
      // });

      map.current.on("mouseenter", "roads", (e) => {
        showRoadPopup(e, popup);
        updateRoadHighlight(e);
      });

      map.current.on("touchstart", "roads", (e) => {
        showRoadPopup(e, popup);
        updateRoadHighlight(e);
      });

      map.current.on("mouseleave", "roads", () => {
        map.current.getCanvas().style.cursor = "";
        popup.remove();
        updateRoadHighlight(null);
      });

      map.current.on("mouseenter", "county-roads", (e) => {
        showRoadPopup(e, popup);
        updateCountyRoadHighlight(e);
      });

      map.current.on("touchstart", "county-roads", (e) => {
        showRoadPopup(e, popup);
        updateCountyRoadHighlight(e);
      });

      map.current.on("mouseleave", "county-roads", () => {
        map.current.getCanvas().style.cursor = "";
        popup.remove();
        updateCountyRoadHighlight(null);
      });

      let hoveredStateId = null;
      let countyHoveredStateId = null;
      function showRoadPopup(e, popup) {
        // Change the cursor style as a UI indicator.
        map.current.getCanvas().style.cursor = "pointer";

        const properties = e.features[0].properties;
        console.log("properties: ", properties);

        let description = "";

        // handle NYS RIS
        if (properties.GIS_ID) {
          let speedLimit = properties.Posted_Speed_Limit
            ? properties.Posted_Speed_Limit
            : "";

          if (properties.Jurisdiction === "02 County") {
            //console.log("find county speed limit");
            const gisId = properties.GIS_ID;
          }

          description = `
                        NYSDOT Road Inventory System<br>
                        Road_Name: ${properties.Road_Name} <br>
                        GIS_ID: ${properties.GIS_ID}<br>
                        Muni_Name: ${properties.Muni_Name}<br>
                        Jurisdiction: ${properties.Jurisdiction} <br>
                        Functional_Class: ${properties.Functional_Class &&
                          functionalClassLookup[
                            properties.Functional_Class
                          ]}<br>
                          Speed: ${speedLimit} <br>
                        Pavement Type: ${properties.Pavement_Type_Value} <br>
                        Shoulder Width: ${properties.Shoulder_Width} <br>
                        Shoulder Type: ${properties.Shoulder_Type} <br>
                        Total_Through_Lane_Width: ${
                          properties.Total_Through_Lane_Width
                        } <br>
                    `;
        }

        // handle county overlay
        if (properties.SPEED) {
          description = `UC DPW Road Data <br>
                        Roadname: ${properties.Roadname} <br>
                        Community: ${properties.COMMUNITY}<br>
                        Speed: ${properties.SPEED} <br>
                        `;
        }

        //<button onclick="handleLocationClick(${properties.CASE_NUM})">More Details</button>

        // Populate the popup and set its coordinates to the current mouse position
        popup
          .setLngLat([e.lngLat.lng, e.lngLat.lat])
          .setHTML(description)
          .addTo(map.current);
      }

      function updateRoadHighlight(e) {
        //console.log("updateRoadHighlight");
        if (hoveredStateId !== null) {
          map.current.setFeatureState(
            { source: "road-inventory", id: hoveredStateId },
            { hover: false }
          );
        }

        if (e && e.features.length > 0) {
          hoveredStateId = e.features[0].id;
          map.current.setFeatureState(
            { source: "road-inventory", id: hoveredStateId },
            { hover: true }
          );
        }
      }

      function updateCountyRoadHighlight(e) {
        //console.log("updateCountyRoadHighlight");
        if (countyHoveredStateId !== null) {
          map.current.setFeatureState(
            {
              source: "county-road-inventory",
              id: countyHoveredStateId,
            },
            { hover: false }
          );
        }

        if (e && e.features.length > 0) {
          countyHoveredStateId = e.features[0].id;
          map.current.setFeatureState(
            {
              source: "county-road-inventory",
              id: countyHoveredStateId,
            },
            { hover: true }
          );
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchCountyOutline = async () => {
    try {
      const response = await fetch(countyOutlineUrl);
      const jsonResponse = await response.json();
      map.current.getSource("county-outline-source").setData(jsonResponse);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleGoogleResponse = async (googleData) => {
    console.log(googleData);
    if (googleData.error) {
      alert("Login cancelled");
      handleModalClose();
      return;
    }
    const res = await fetch("/api/v1/auth/google", {
      method: "POST",
      body: JSON.stringify({
        token: googleData.tokenId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();

    console.log("user data from server", data);
    localStorage.setItem("user", JSON.stringify(data));

    //alert("Welcome " + data.firstName);
    handleModalClose();
  };

  function rotateCamera(timestamp) {
    // clamp the rotation between 0 -360 degrees
    // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
    map.current.rotateTo((timestamp / 100) % 360, { duration: 0 });
    // Request the next frame of the animation.
    requestAnimationFrame(rotateCamera);
  }

  useEffect(() => {
    if (!map.current) return; // wait for map to initialize
    map.current.on("move", () => {
      setCurrentLong(map.current.getCenter().lng.toFixed(4));
      setCurrentLat(map.current.getCenter().lat.toFixed(4));
      setCurrentZoom(map.current.getZoom().toFixed(2));
    });
  });

  const getUserLocation = () => {
    console.log("getUserLocation");

    navigator.geolocation.getCurrentPosition((position) => {
      console.log("position response", position);

      map.current.flyTo({
        center: [position.coords.longitude, position.coords.latitude],
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      });
    });
  };

  const onSliderChange = (newDateRange) => {
    setStartDate(newDateRange[0]);
    setEndDate(newDateRange[1]);
  };

  const injuryOptions = [
    { value: "all", label: "Injury Severity", color: "#FF5630" },
    { value: "all", label: "All", color: "#FF5630" },
    { value: "K", label: "Killed", color: "#FF5630" },
    { value: "A", label: "Incapacitated", color: "#FF5630" },
    { value: "B", label: "Not Incapacitated", color: "#FF5630" },
    { value: "C", label: "Possibly Injuried", color: "#FF5630" },
    { value: "D", label: "Unknown", color: "#FF5630" },
  ];

  const onInjuryChange = (newInjurySetting) => {
    console.log("onInjuryChange", newInjurySetting);
    setInjuryFilter(newInjurySetting.value);
  };

  useEffect(() => {
    if (crashes.length < 1) return;
    console.log("accidentFitering");

    const startDateEpoch = new Date(startDate + "-01-01").valueOf();
    const endDateEpoch = new Date(Number(endDate + 1) + "-01-01").valueOf();

    const filters = [
      "all",
      [">=", ["get", "accidentDateEpoch"], startDateEpoch],
      ["<", ["get", "accidentDateEpoch"], endDateEpoch],
    ];

    let crashesFiltered = [...crashes.features]
      .filter((f) => f.properties.accidentDateEpoch >= startDateEpoch)
      .filter((f) => f.properties.accidentDateEpoch < endDateEpoch);

    if (injuryFilter !== "all") {
      filters.push([
        "in",
        ["get", "mostSevereInjury"],
        ["literal", [injuryFilter]],
      ]);

      crashesFiltered = crashesFiltered.filter(
        (f) => f.properties.mostSevereInjury === injuryFilter
      );
    }

    const filteredObject = { ...crashes, features: crashesFiltered };
    map.current.getSource("crashes-source").setData(filteredObject);
    //map.current.setFilter("unclustered-point", filters);
    // map.current.setFilter("clusters", filters);
    // map.current.setFilter("cluster-count", filters);

    const pCrashes = crashesFiltered.filter(
      (f) =>
        f.properties.ACCD_TYP === "02" ||
        f.properties.ACCD_TYP === "04" ||
        f.properties.ACCD_TYP === "06"
    );
    const bCrashes = crashesFiltered.filter(
      (f) => f.properties.ACCD_TYP === "03"
    );

    setBikeCrashes(bCrashes);
    setPedCrashes(pCrashes);
    setCrashesFiltered(filteredObject);
  }, [startDate, endDate, injuryFilter, cacheBust, crashes]);

  const loadNYSDOT = async () => {
    console.log("loadNYSDOT");
    const res = await fetch(roadUrl);
    const rawRoadData = await res.json();
    map.current.getSource("road-inventory").setData(rawRoadData);
  };

  const loadUCDPW = async () => {
    console.log("loadUCDPW");
    const resUCRoads = await fetch(ucRoadsJoinedUrl);
    let ucRoads = await resUCRoads.json();

    // add id field for hover purposes
    ucRoads.features = ucRoads.features.map((f) => {
      if (!f.properties.id) {
        f.properties.id = uuidv4();
      }
      return f;
    });
    map.current.getSource("county-road-inventory").setData(ucRoads);
  };

  const loadAboutModal = async () => {
    console.log("loadAboutModal");
    handleModalOpen();
  };

  const flyToCrash = async (crashId) => {
    console.log("flyToCrash: " + crashId);

    if (!crashId) {
      console.log("setting default crashId off latest crash available");
      const latest =
        crashesFiltered.features[crashesFiltered.features.length - 1];
      console.log("latest", latest);
      const latestCaseNumber = latest.properties.CASE_NUM;
      crashId = latestCaseNumber;
    }

    setCurrentCrashId(crashId);

    console.log("crashId", crashId);

    // find by case number
    const currentCrash = crashesFiltered.features.find(function(f, index) {
      //console.log("f.properties.CASE_NUM: " + f.properties.CASE_NUM);
      if (String(f.properties.CASE_NUM) === String(crashId)) {
        return true;
      }
      return false;
    });

    console.log("currentCrash", currentCrash);

    const crashCoordinates = currentCrash?.geometry?.coordinates;
    console.log("crashCoordinates", crashCoordinates);

    map.current.once("moveend", () => {
      console.log("moveend");
      setPopupCrashId(crashId);
    });

    let curZoom = currentZoom;
    if (curZoom < 16) {
      curZoom = 16;
    }

    map.current.flyTo({
      padding: { top: 200 },
      zoom: curZoom,
      center: crashCoordinates,
      essential: true, // this animation is considered essential with respect to prefers-reduced-motion
    });

    console.log("crashes", crashes);
  };

  useEffect(() => {
    console.log("popupCrashId: " + popupCrashId);
    if (!popupCrashId) return;
    if (!crashesFiltered || crashesFiltered.length < 1) return;

    if (popup) {
      popup.remove();
    } else {
      // Create a popup, but don't add it to the map yet.
      popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        closeOnMove: true,
      });
    }

    // Change the cursor style as a UI indicator.
    map.current.getCanvas().style.cursor = "pointer";

    // find by case number
    let currentIndex;
    //console.log("crashes", crashes);
    const currentCrash = crashes.features.find(function(f, index) {
      //console.log("f.properties.CASE_NUM: " + f.properties.CASE_NUM);
      if (String(f.properties.CASE_NUM) === String(popupCrashId)) {
        currentIndex = index;
        return true;
      }
      return false;
    });

    const crashCoordinates = currentCrash?.geometry?.coordinates;
    //console.log("crashCoordinates", crashCoordinates);

    const properties = currentCrash.properties;
    console.log("properties: ", properties);
    const description = `Date: ${properties.ACCD_TME_STR} <br>
                Type: ${properties.ACCD_TYP &&
                  accidentTypes[properties.ACCD_TYP]}<br>
                Case: ${properties.CASE_NUM} <br>
                Injuries: ${decodeInjuries(properties.EXT_OF_INJURIES)}<br>
                Reporting Agency: ${properties.RPT_AGCY} <br>
                <button onclick="openStreetView(${crashCoordinates[0]}, ${
      crashCoordinates[1]
    })">Street View</button>
            `;

    // Populate the popup and set its coordinates
    // based on the feature found.
    popup
      .setLngLat(crashCoordinates)
      .setHTML(description)
      .addTo(map.current);

    // update hash
    let newHashString = "";
    if (currentZoom && currentLat && currentLong) {
      newHashString = `zoom=${currentZoom}&lat=${currentLat}&long=${currentLong}&`;
    }
    newHashString += `case=${popupCrashId}&`;
    // window.location.hash = newHashString;

    setCurrentViewHash(newHashString);
    setHash(newHashString);
  }, [popupCrashId, crashes, cacheBust]);

  useEffect(() => {
    //console.log("hash change ----- ", hash);

    if (!hash) return;
    const hashTrimmed = hash.substring(1, hash.length); // remove leading # from hash

    if (currentViewHash !== hashTrimmed) {
      // console.log("responding to hash change", currentViewHash, hashTrimmed);
      const newHashParams = getHashParams();

      // make sure we've got the right number of elements
      if (!newHashParams.zoom || !newHashParams.lat || !newHashParams.long)
        return;

      if (newHashParams.case) {
        map.current.once("moveend", () => {
          console.log("moveend");
          setPopupCrashId(Number(newHashParams.case));
        });
      }

      map.current.flyTo({
        zoom: newHashParams.zoom,
        center: { lng: newHashParams.long, lat: newHashParams.lat },
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      });
    }
  }, [hash]);

  const previousCrash = async () => {
    console.log("previousCrash");

    let crashId = currentCrashId;
    if (!currentCrashId) {
      console.log("default to latest crash");
      flyToCrash();
      return;
    }

    // find by case number
    let currentIndex;
    const currentCrash = crashesFiltered.features.find(function(f, index) {
      //console.log("f.properties.CASE_NUM: " + f.properties.CASE_NUM);
      if (String(f.properties.CASE_NUM) === String(currentCrashId)) {
        currentIndex = index;
        return true;
      }
      return false;
    });

    console.log("------ currentCrash: ", currentCrash);

    // if current crash isn't part of the filtered crashes, reset default
    if (!currentCrash) {
      console.log(
        "could not find current crash in filtered crashes, resetting to most recent"
      );
      setCurrentCrashId(null);
      flyToCrash();
      return;
    }

    // console.log("------ currentIndex", currentIndex);
    const previousCrash = crashesFiltered.features[currentIndex - 1];
    // console.log("------ previousCrash", previousCrash);
    const previousCrashId = Number(previousCrash.properties.CASE_NUM);

    // console.log("------ previousCrashId", previousCrashId);
    flyToCrash(previousCrashId);
  };

  return (
    <div>
      <div>
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              SharedRoads.com
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Get updates on crash data and other changes to the map by logging
              in with your Google account.
            </Typography>
            <br />
            <GoogleLogin
              clientId="98954964635-i5aahbllslebn0lgu3l1id5odgocncua.apps.googleusercontent.com"
              buttonText="Login with your Google Account"
              onSuccess={handleGoogleResponse}
              onFailure={handleGoogleResponse}
              cookiePolicy={"single_host_origin"}
            />
          </Box>
        </Modal>
      </div>
      <div className="sidebar">
        {/* Longitude: {lng} | Latitude: {lat} | Zoom: {zoom} |  */}
        Ulster County - Vehicle vs Bike/Ped Collisions <br />
        Pedestrian: {pedCrashes.length}
        &nbsp; Bike: {bikeCrashes.length} &nbsp; <br />
        {/* <Select options={options} /> */}
        Start Year: {startDate} End Year: {endDate}
        <br /> <br />
        <div className="timeline">
          <TimeSlider onChange={onSliderChange} />
        </div>
        <Select
          defaultValue={[injuryOptions[0]]}
          name="injuryFilter"
          options={injuryOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={onInjuryChange}
          styles={{
            option: (base) => ({
              ...base,
              background: "#023950",
              height: "100%",
            }),
          }}
        />
        <button id="loadRoadDataButton" onClick={loadNYSDOT}>
          NYSDOT RIS
        </button>
        <button id="loadUCRoadDataButton" onClick={loadUCDPW}>
          UC DPW
        </button>
        <button id="loadUCRoadDataButton" onClick={loadAboutModal}>
          About this map
        </button>
        <button
          id="flyToCrashButton"
          onClick={() => {
            flyToCrash(null);
          }}
        >
          most recent
        </button>
        <button id="zoomToPrevCrashButton" onClick={previousCrash}>
          previous
        </button>
      </div>

      <div ref={mapContainer} className="map-container" />
    </div>
  );
}

export function TimeSlider({ onChange }) {
  const labelStyle = { minWidth: "60px", display: "inline-block" };
  const inputStyle = { marginBottom: "10px" };
  return (
    <div>
      <Range
        dots
        min={2002}
        max={2021}
        allowCross={false}
        defaultValue={[2002, 2021]}
        onChange={onChange}
      />
    </div>
  );
}

const PopupBase = ({ children, lngLat, ...mapboxPopupProps }) => {
  const { map } = useContext(mapContext);
  const popupRef = useRef();

  useEffect(() => {
    const popup = new mapboxgl.Popup({})
      .setLngLat(lngLat)
      .setDOMContent(popupRef.current)
      .addTo(map);

    return popup.remove;
  }, [children, lngLat]);

  return (
    <div style={{ display: "none" }}>
      <div ref={popupRef}>{children}</div>
    </div>
  );
};

const useHash = () => {
  const [hash, setHash] = React.useState(() => window.location.hash);

  const hashChangeHandler = React.useCallback(() => {
    setHash(window.location.hash);
  }, []);

  React.useEffect(() => {
    window.addEventListener("hashchange", hashChangeHandler);
    return () => {
      window.removeEventListener("hashchange", hashChangeHandler);
    };
  }, []);

  const updateHash = React.useCallback(
    (newHash) => {
      if (newHash !== hash) window.location.hash = newHash;
    },
    [hash]
  );

  return [hash, updateHash];
};

const getHashParams = () => {
  let currentHashString = window.location.hash;
  // trim off the hash
  currentHashString = currentHashString.substring(
    currentHashString.indexOf("#") + 1,
    currentHashString.length
  );
  console.log("currentHashString: ", currentHashString);
  let currentHash = parseParms(currentHashString);
  console.log("currentHash: ", currentHash);
  return currentHash;
};
